export const SliderBenefits = {
	name: 'SliderBenefits',
	render(h) {
		if (!this.$slots.default) {
			return;
		}

		let page = h('div', { class: ['benefit__page'] }, []);
		let slots = this.$slots.default.filter(slot => slot.tag);

		let items = slots.reduce((acc, cur, index) => {
			page.children.push(cur);

			if ((index + 1) % 4 == 0 || slots.length - 1 == index) {
				acc.push(page);
				page = h('div', { class: ['benefit__page'] }, []);
			}
			return acc;

		}, [])

		this.$parent.$emit('update-data', Math.ceil(items.length / 3), 1);

		return h(
			'div',
			{ class: ['benefits'] },
			[items]
		)
	}
}
